import React from "react";
import "./styles.css";
import { SVGAsset } from "res";
import { BCMSDate } from "bcms-react";

/**
 * @function ChatMessageWidget
 * @param {STRING} className - Allows us to pass a unique class to each ChatMessageWidget.
 * @param {STRING} receivedTime - Allows us to set the received date of the ChatMessageWidget.
 * @param {STRING} message - Allows us to set the message of the ChatMessageWidget.
 * @param {React.Component} children - Allows us to inject other components/content.
 * @example
 * <ChatMessageWidget className="some-class" receivedTime="[00:00:00 PM]" message="This is the message.">
 *    <span>Injected Content</span>
 * </ChatMessageWidget>
 */
export default function ChatMessageWidget(props) {
  const className = props.className ?? "";
  const receivedTime = props.receivedTime ?? BCMSDate.init().format("h:i:sp").toLowerCase();
  const message = props.message ?? "Sorry, all agents are busy. Please wait for the next available agent or try again later.";

  return (
    <div className={`${className} chat-message-widget`}>
      {props.children}
      <div className="message-text-container flex-container flex-horizontal align-center">
        <div className="message-text flex-container flex-horizontal align-center">
          <span>{ props.icon }</span>
          <span>
            <span className="time-text sub-text">[{ receivedTime }] </span>
            { message }
          </span>
        </div>
      </div>
    </div>
  );
}

export function ReceivedMessageWidget(props) {
  return (
    <ChatMessageWidget className="received-message-widget" {...props} />
  );
}

/**
 * @function SentMessageWidget
 * @param {STRING} message - Allows us to set the message of the SentMessageWidget.
 * @param {STRING} sentTime - Allows us to set the received date of the SentMessageWidget.
 * @example
 * <SentMessageWidget sentTime="[00:00:00 PM]" message="This is the message." />
 */
export function SentMessageWidget(props) {
  const message = props.message ?? "[message]";

  return (
    <div className="sent-message-widget chat-message-widget">
      <div className="flex-container flex-horizontal align-center date-container">
        <div className="set-width">
          <span className="date-text sub-text">[{ props.sentTime }]</span>
        </div>
        <div className="flex-width">
          <span className="label-text">You</span>
        </div>
      </div>

      <div className="message-text-container flex-container flex-horizontal align-center">
        <div className="message-text flex-container flex-horizontal align-center">
          <span>{ props.icon }</span>
          <span>
            { message }
          </span>
        </div>
      </div>
    </div>
  );
}

/**
 * @function EndedMessageWidget
 * @param {STRING} endTime - Allows us to set the received date of the EndedMessageWidget.
 * @example
 * <EndedMessageWidget endTime="[00:00:00 PM]" />
 */
export function EndedMessageWidget(props) {
  return (
    <ChatMessageWidget className="ended-message-widget" icon={<SVGAsset id="XMessageBubbleIcon" />} message="Session Ended" receivedTime={ props.endTime } />
  );
}